import React from "react";
import { TextField, MenuItem } from "@mui/material";

const discountTypes = [
  "buy_x_get_y",
  "threshold_discount",
  "product_discount",
  "category_discount",
  "subcategory_discount", // ✅ New
  "free_gift",
  "custom",
];

const TypeSelector = ({ form, handleChange }) => {
  return (
    <TextField
      fullWidth
      select
      label="Type"
      value={form.type}
      onChange={(e) => handleChange("type", e.target.value)}
      sx={{ mb: 2 }}>
      {discountTypes.map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TypeSelector;
